import styled from 'styled-components';
import SafeDiningSvg from '../../../assets/onboardingNew/homepage/safe-dining.svg';

const SafeDiningNewIcon = styled(SafeDiningSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.9rem'};
height: ${props => props.height || '3.2rem'};
display: flex;
`;

export default SafeDiningNewIcon;
